<template>
    <div id="caseList" class="sys-page">
        <!-- 查询 -->
        <div>
            <el-form :inline="true" :model="searchForm" style="padding:0 10px;text-align:center">
                <el-form-item label="姓名">
                    <el-input v-model="searchForm.patientName" style="width:250px;" placeholder="患者姓名"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="searchForm.patientGender" placeholder="患者性别"  style="width:250px;">
                        <el-option v-for="item in sex" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请时间：">
                    <el-date-picker v-model="applyTime" style="width:350px" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="applyTimeChange">
                    </el-date-picker>
                </el-form-item>
                <br>
                <el-form-item label="申请医院">
                    <el-select v-model="searchForm.applyHospId" filterable  placeholder="申请医院"  style="width:250px;">
                        <el-option v-for="item in hospList" :key="item.hospVo.hospId" :label="item.hospVo.hospName" :value="item.hospVo.hospId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="诊断医院">
                    <el-select v-model="searchForm.diagHospId" filterable placeholder="诊断医院"  style="width:250px;">
                        <el-option v-for="item in hospList" :key="item.hospVo.hospId" :label="item.hospVo.hospName" :value="item.hospVo.hospId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="病例状态">
                    <el-select v-model="searchForm.caseStatus" placeholder="病例状态"  style="width:250px;">
                        <el-option key="01" label="暂存" value="01"></el-option>
                        <el-option key="02" label="待申请" value="02"></el-option>
                        <el-option key="03" label="待付款" value="03"></el-option>
                        <el-option key="04" label="待诊断" value="04"></el-option>
                        <el-option key="05" label="诊断中" value="05"></el-option>
                        <el-option key="06" label="被驳回" value="06"></el-option>
                        <el-option key="07" label="已完成" value="07"></el-option>
                        <el-option key="10" label="已取消" value="10"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="success" circle @click="search()"></el-button>
                    <el-button icon="el-icon-delete" type="danger" circle @click="clear()"></el-button>
                    <el-button icon="el-icon-download" type="warning" circle @click="downLoad()"></el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align:right; width: 98%;">
            <el-button type="primary" size="small" @click="refresh()">刷新</el-button>
        </div>
        <div class="main-data">
            <el-table :data="tableData.body" style="width: 98%;margin:0 auto">
                <el-table-column header-align=center align="center" type=index label="序号" width="50"></el-table-column>
                <el-table-column header-align=center align="center" prop="patientName" label="姓名"></el-table-column>
                <el-table-column header-align=center align="center" prop="patientGender" label="性别" :formatter="sixForamt"></el-table-column>
                <el-table-column header-align=center align="center" prop="patientAge" label="年龄"></el-table-column>
                <el-table-column header-align=center align="center" prop="applyTime" label="申请时间" width="170"></el-table-column>
                <el-table-column header-align=center align="center" prop="applyHospName" label="申请医院" width="300"></el-table-column>
                <el-table-column header-align=center align="center" prop="diagHospName" label="诊断医院" width="300" :formatter="diagHospD"></el-table-column>
                <el-table-column header-align=center align="center" prop="deviceType" label="设备类型" width="170" :formatter="deviceForamt"></el-table-column>
                <el-table-column header-align=center align="center" prop="caseStatus" label="病历状态" :formatter="transformStatus"></el-table-column>
                <el-table-column align =center label="操作" header-align=center width="100">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="viewMsg(scope.row)">查看病历</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination  :page-size='rows' :current-page='page' 
                :page-sizes="[20,50,100]" :page-count="5" layout="total, prev, pager, next,sizes" :total="tableData.count" @current-change='currentChange' @size-change="changeSize" style="text-align:right"></el-pagination>
        </div>
        <el-dialog title="" :visible.sync="caseMsg" width="60%" center>
            <el-form ref="form" :model="form" label-width="110px">
                <div class="box">
                    <p class="title">病历信息</p>
                    <el-card class="box-card">
                        <div class="itemBox">
                            <el-form-item label="姓名 ：">
                                <p>{{form.patientName}}</p>
                            </el-form-item>
                            <el-form-item label="性别 ：">
                                <p>{{form.patientGender=="F"?'女':'男'}}</p>
                            </el-form-item>
                            <el-form-item label="手机号 ：">
                                <p>{{form.patientTel}}</p>
                            </el-form-item>
                        </div>
                        <div class="itemBox">
                            <el-form-item label="年龄 ：">
                                <p>{{form.patientAge+'岁'}}</p>
                            </el-form-item>
                            <el-form-item label="设备类型 ：">
                                <p>{{form.deviceType}}</p>
                            </el-form-item>
                            <el-form-item label="起搏器 ：">
                                <p>{{form.pacemakerVal=="1"?'有':'无'}}</p>
                            </el-form-item>
                        </div>
                        <div class="itemBox">
                            <el-form-item label="备注 ：" style="width:100% !important;">
                                <p>{{form.comment}}</p>
                            </el-form-item>
                        </div>
                        <el-form-item label="药史 ：" style="width:100% !important;">
                            <p>{{form.medicineHistory}}</p>
                        </el-form-item>
                        <el-form-item label="病史 ：" style="width:100% !important;">
                            <p>{{form.medicalHistory}}</p>
                        </el-form-item>
                        <el-form-item label="主诉 ：" style="width:100% !important;">
                            <p>{{form.medicalComplaint}}</p>
                        </el-form-item>
                        <el-form-item label="初诊 ：" style="width:100% !important;">
                            <p>{{form.medicalComplaint}}</p>
                        </el-form-item>
                        <!-- <el-form-item label="附件 ：" style="width:100% !important;">
                            <li class="fileList"  v-for="item in form.examAttach" @click='openFile(item.attachUrl)'><i class="el-icon-download" />{{item.attachName}}</li>
                        </el-form-item> -->
                    </el-card>
                    <!-- <p class="title">检查文件</p>
                    <el-card class="box-card">
                        <el-form-item label="检查文件 ：" style="width:100%!important">
                            <li class="fileList" v-for="item in form.ecgAttach" @click='openFile(item.attachUrl)'><i class="el-icon-download" />{{item.attachName}}</li>
                        </el-form-item>
                    </el-card> -->
                    <!-- <el-button @click="caseMsg=false" style="margin-top:20px;">返回</el-button> -->
                    <p class="title" v-if="form.caseStatus=='07'">诊断结果</p>
                    <el-card class="box-card" v-if="form.caseStatus=='07'">
                        <el-form-item label="诊断意见 ：">
                            <p>{{caseDiag.diagSuggest}}</p>
                        </el-form-item>
                        <el-form-item label="诊断报告 ：" style="width:100%!important">
                            <li class="fileList" @click='openFile(caseDiag.reportUrl)'><i class="el-icon-download" />{{caseDiag.reportName}}</li>
                        </el-form-item>
                    </el-card>
                    <p class="title" v-if="form.caseStatus=='06'">驳回结果</p>
                    <el-card class="box-card" v-if="form.caseStatus=='06'">
                        <el-form-item label="驳回原因 ：">
                            <p>{{caseDiag.diagSuggest}}</p>
                        </el-form-item>
                    </el-card>
                    <!-- 
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="payOrder(form)" v-if="form.caseStatus=='03'">支付</el-button>
                        <el-button @click="cancel(form)" v-if="form.caseStatus=='01'||form.caseStatus=='02'||form.caseStatus=='03'">取消申请</el-button>
                        <el-button type="primary" @click="apply(form)" v-if="form.caseStatus=='02'">申请诊断</el-button>
                    </span> -->
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
const OSS = require('ali-oss')
import { Loading } from 'element-ui';
export default {
    data(){
        return{
            userInfo:{},
            sexValue: null,
            url:'https://t-new-dongtaiecg.oss-cn-beijing.aliyuncs.com/', 
            sex:[{   
                value: 'M',
                label: '男'
             },
             {   
                value: 'F',
                label: '女' 
            }],
            tableData: {
                body: [],
                count: 10,
                page: '1'
            },
            applyTime:[],
            searchForm: {
                patientGender: '',
                patientName: '',
                caseStatus:'',
                applyHospId:'',
                diagHospId:'',
                startApplyTime:'',
                endApplyTime:'',
            },
            page:1,
            rows:20,
            hospList:[],
            caseMsg:false,
            form:{},
            region: 'oss-cn-beijing', //'cn-beijing',//
            bucket: 't-new-dongtaiecg', //文件夹名
            client:'',
            caseDiag:{
                diagSuggest:'',
                reportUrl:'',
                reportName:'',
            }
        }
    },
    mounted(){
        this.userInfo=this.$common.getStorage('userInfo');
        this.initData();
        this.getHospList();
        this.getOss();
    },
    methods: {
        search(){
            this.initData();
        },
        //申请时间段选择
        applyTimeChange(val){
            this.searchForm.startApplyTime=this.$common.format(val[0],'yyyy-MM-dd')+' 00:00:00';
            this.searchForm.endApplyTime=this.$common.format(val[1],'yyyy-MM-dd')+' 23:59:59';
        },
        //获取医院列表
        getHospList(){
            this.$ajax.post(this.$domain.listHospInfo,{
                page:1,
                rows:1000
            })
            .then(ret=>{
                var res=ret.data;
                if(res.code=="10"){
                    this.hospList=res.data.list;
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
                else{
                    console.log(res)
                }
            })

        },
        //获得病例列表
        initData(){
            this.searchForm.page=this.page
            this.searchForm.rows=this.rows
            this.$ajax.post(this.$domain.getCaseList,this.searchForm)
            .then(ret=>{
                this.$common.getConsole('caseList.vue--获得病例列表',ret.data)
                if(ret.data.code==10){
                    this.tableData.body=ret.data.data.list;
                    this.tableData.count=ret.data.data.count;
                }
                else if(ret.data.code==11){
                    this.tableData.body=[];
                    this.tableData.count=0;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        downLoad(){
            // alert("即将上线!");
            // return
            if(this.$common.exportMax(this.tableData.count)){
                return
            }
            let loadingInstance = Loading.service({ fullscreen: true,text:'正在生成表格文稿' ,spinner:'el-icon-loading'});
            this.$ajax.post(this.$domain.exportCaseStatistics,this.searchForm)
            .then(ret=>{
                loadingInstance.close();
                this.$common.getConsole('caseList.vue--获得病例列表',ret.data)
                if(ret.data.code==10){
                    window.open(this.url + ret.data.data);
                    let _this=this;
                    setTimeout(function () {
                        _this.deleteMsg(ret.data.data)
                    },300000)
                }
                else{
                    this.$message.error("导出失败")
                }
            })
        },
        currentChange(page) {
            this.page = page;
            this.initData() 
        },
        changeSize(rows) {
            this.rows = rows;
            this.initData() 
        },
        clear(){
            this.searchForm={
                patientGender: '',
                patientName: '',
                caseStatus:'',
                applyHospId:'',
                diagHospId:'',
                startApplyTime:'',
                endApplyTime:'',
            },
            this.page=1;
            this.search();
        },
        //查看病历信息
        viewMsg(row){
                console.log(row)
                this.form=row;
                this.form.deviceType=this.deviceForamt(row)
                this.caseMsg=true;
                if(row.caseStatus=='07' || row.caseStatus=='06'){
                    this.$ajax.post(this.$domain.getDiag,{
                        caseId:row.caseId
                    }).then(res=>{
                        if(res.data.code==10){
                            this.caseDiag=res.data.data
                        }
                    })
                }
        },
        //打开文件
        openFile(url){
            window.open(this.url+url);
        },
        getOss(){
          //获得oss临时账号
          this.$ajax.post(this.$domain.getReadAndWriteOSS,{})
            .then( res => {
              this.$common.getConsole('upload——获取oss',res.data)
              if (!(res.data.data)) {
                throw new Error('获取OSS参数失败')
              }
              this.client = new OSS({
                region: this.region,
                accessKeyId: res.data.data.ossAccessKeyId,
                accessKeySecret: res.data.data.ossAccessKeySecret,
                stsToken: res.data.data.ossSecurityToken,
                bucket: this.bucket
              })
            })
        },
        //删除附件
        deleteMsg(val){
          this.client.delete(val);
        },
        //性别转换
        sixForamt(row){
            return row.patientGender == 'F' ? "女" : "男";
        },
        //状态文字转换
        transformStatus(row){
            switch(row.caseStatus){
                case '01':return '暂存';break;
                case '02':return '待申请';break;
                case '03':return '待付款';break;
                case '04':return '待诊断';break;
                case '05':return '诊断中';break;
                case '06':return '被驳回';break;
                case '07':return '已完成';break;
                case '08':return '订单未接受超时';break;
                case '09':return '订单诊断超时';break;
                case '10':return '已取消';break;
                case '99':return '未定义';break;
            }
        },
        //急诊文字转换
        transformEmerg(row){
            switch(row.emergStatus){
                case 0:return '否';break;
                case 1:return '是';break;
            }
        },
        //设备类型文字转化
        deviceForamt(row){
            switch(row.deviceType){
                case '01':return '动态心电';break;
                case '02':return '动态血压';break;
                case '03':return '动态心电血压二合一';break;
                case '04':return '18导动态心电';break;
            }
        },
        diagHospD(row){
            if(row.caseDiagType=='01'){
                return row.diagHospName+'('+row.diagDeptName+')';
            }else{
                return row.diagHospName;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    #caseList {
        .main-data{
            margin-top: 20px;
            .el-button{
                padding-left: 5px;
                padding-right: 5px;
                height: 30px;
                .white-class{
                    color: #ffffff;
                }
            }
        }
        .box{
            width:90%;
            max-width:1400px;
            margin: auto;
            margin-bottom:20px;
            font-size: 18px;
            .title{
                font-size: 24px;
                margin-top:30px;
                text-align: left;
                color:#5c6bc0;
                font-weight: bold;
                padding:10px 10px;
                border-bottom:1px solid #5c6bc0;
            }
            .box-card{
                margin-top:20px;
                .itemBox{
                    display: flex;
                    justify-content: space-around;
                }
                .el-form-item{
                    width:33%!important;
                    text-align: left;
                }
                .el-form-item__content{
                    margin:0!important;
                }
                .fileList{
                    list-style: none;
                    margin-right:20px;
                    cursor: pointer;
                    color:#07b107
                }
                .fileList:hover{
                    color:#017a01;
                }
            }
            .dialog-footer{
                display: flex;
                margin-top:20px;
            }
        }
        width:100%;
        min-width:1400px;
        padding:20px 40px;
        box-sizing: border-box;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/page/caseList.vue